import _ from 'lodash';
import {GeneralService} from '../../../services/generalService';
import {RouteService} from '../../../services/routeService';
import {NotificationService} from '../../../services/notificationService';
import {DICTIONARY} from '../../../dictionary';
import {Component, OnInit} from "@angular/core";
import util from "util";
import {ENV_CONSTS} from "../../../constants";
import {HttpClient} from "@angular/common/http";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {AuthService} from "../../../services/authService";

@Component({
	selector: 'threat-simulation-training-materials-component',
	templateUrl: './threat-simulation-training-materials.component.html',
})
export class ThreatSimulationTrainingMaterialsComponent implements OnInit {

	constructor(public gs:GeneralService,
				private rs:RouteService,
				private http:HttpClient,
				private authService:AuthService,
				public sanitizer: DomSanitizer,
				private ns:NotificationService) {
	}

	dic = DICTIONARY;
	_ = _;
	getMaterialsInProcess;
	getMaterialFileDataInProcess;
	currentMaterial;
	previewLinkMaterial: SafeResourceUrl;
	editMaterialInProcess;
	searchMaterialTxt;
	materials: any;
	materialsForGallery: any;
	isThisFeatureSupported;
	validDrag;
	pageViews = {
		gallery: 'gallery',
		table: 'table',
	};
	readonly cfStreamBase = 'https://customer-l20evnb6f5ogvb0i.cloudflarestream.com';
	pageView = this.pageViews.gallery;
	invalidDrag;
	newMaterialPopup;
	quizCreationPopup;
	aiMaterialPopup;
	aiMaterialPopupSteps = {
		generalInformation: 'General Information',
		materialDetails: 'Material Details',
		generate: 'Generate Video'
	};
	aiMaterialAudienceOptions = [
		'All employees',
		'QA team',
		'R&D team',
		'IT department',
		'HR department',
		'Finance team',
		'Sales team',
		'Customer support',
		'Executives and management',
		'New employees / onboarding',
		'Remote workers',
		'Admins and privileged users',
	];
	aiCreationGifLoaded = false;
	alreadyUploadedFiles;
	uploadQueue;
	materialTags = [
		{name: 'AI', inTypes: ['AI', 'Trustifi AI'], color: '#1d8500', iconClass: 'fa fa-magic'},
		{name: 'Video', inTypes: ['AI', 'Trustifi AI', 'Hook Security', 'video/mp4'], color: '#b12424', iconClass: 'far fa-video'},
		{name: 'Link', inTypes: ['link'], color: '#197d90', iconClass: 'far fa-link'},
		{name: 'Presentation', inTypes: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'], color: '#F5A623', iconClass: 'far fa-file-powerpoint'},
		{name: 'PDF File', inTypes: ['application/pdf'], color: '#8E44AD', iconClass: 'far fa-file-pdf'},
		{name: 'Quiz', inTypes: ['quiz'], color: '#c2188c', iconClass: 'far fa-question-circle'},
	];
	filterData;
	activeFilters;

	ngOnInit() {
		this.getThreatSimulationMaterials();
		this.initFilters();
	};

	getThreatSimulationMaterials = () => {
		this.getMaterialsInProcess = true;
		this.rs.getThreatSimulationMaterials().then((response) => {
			this.isThisFeatureSupported = true;

			this.materials = response || [];
			this.materials.forEach((videoObj) => {
				this.getThumbnailUrl(videoObj);
			});

			this.updateMaterialsGallery();

			this.getMaterialsInProcess = false;
		}, (err) => {
			if (err?.data?.message && err.data.message.includes('This feature is not supported')) {
				this.isThisFeatureSupported = false;
			}

			this.getMaterialsInProcess = false;
		});
	};

	getThumbnailUrl = (video) => {
		if (video.link_url && video.id) {
			const t = Math.floor(Math.random() * 28) + 10;
			video.thumbnail = `${this.cfStreamBase}/${video.id}/thumbnails/thumbnail.jpg?time=${t}s&height=270`;
		}
	};

	updateMaterialsGallery = () => {
		if (this.pageView === this.pageViews.gallery) {
			this.materialsForGallery = {
				user: this.materials.filter(material => material.type !== 'Trustifi AI' && material.type !== 'Hook Security' && !(material.type === 'quiz' && material.system)),
				trustifi: this.materials.filter(material => material.type === 'Trustifi AI' || (material.type === 'quiz' && material.system)),
				hookSecurity: this.materials.filter(material => material.type === 'Hook Security')
			};
		}

		this.setMaterialTags();
	}

	setMaterialTags = () => {
		this.materials.forEach(material => {
			// use "metaTags" because "tags" keyword is already taken
			material.metaTags = this.materialTags.filter(tag => tag.inTypes.includes(material.type));

			// video subtitles tag (CC)
			material.subtitlesData = (material.video_subtitles || []).map(subtitle => {
				return {
					lang: this.dic.CONSTANTS.subtitleLanguages[subtitle.lang],
					isInProcess: !subtitle.segments?.length
				};
			});
			material.completedSubtitles = (material.video_subtitles || []).filter(subtitle => subtitle.segments?.length).map(subtitle => this.dic.CONSTANTS.subtitleLanguages[subtitle.lang]);

		});
	}

	initFilters = () => {
		this.filterData = {
			filterType : this.dic.CONSTANTS.tableFilters.discoveredServices,
			filters: {
				'Material Type': ['PDF file', 'Link', 'Powerpoint presentation', 'Video', 'Quiz'],
				'Video Type': ['Trustifi AI video', 'Hook Security video', 'AI Generated video'],
				'Tags': ["Phishing","Email-security","Awareness","Quiz","Interactive","Passwords","Mfa","Account-security","Authentication","Wire-fraud","Business-email-compromise","Social-engineering","Credential-harvest","Ransomware","Malware","Threat-prevention","Security-awareness","Data privacy","General security","Ai","Ai security","Artificial intelligence","Deepfake","Mobile threat","Smishing","Sms attack","Identity access","Bec attack","Gift card scam","Case study","Cyber attacks","Information security","Osint exploit","Link spoofing","Url phishing","Identity fraud","Ai deepfake","Ai threat","Smartphone attack","Insider threat","Trojan","Virus","Qr code phishing","Quishing","Security awareness training","Spear phish"],
				'Audience': ["Employee","Manager","Admin"],
				'Skill Level': ["Beginner","Intermediate"],
				'Attack Type': ["BEC","Credential_harvest","Ransomware","Data_loss","Osint_exploit","Link_spoof","Vishing","Brand_spoof","Shadow_it","Spyware","Qr_phish","Spear_phish"],
				'Delivery Vector': ["Email","Web","Sms","Voice"]
			},
			initFiltersFunction: this.initFilters
		};
	};

	showMaterialActions = (materialObj) => {
		return _.compact([
			!materialObj.link_url && materialObj.type !== 'quiz' && _.capitalize(this.dic.CONSTANTS.actions.download),
			materialObj.type === 'quiz' && 'Edit',
			materialObj.type === 'quiz' && 'Duplicate',
			_.capitalize(this.dic.CONSTANTS.actions.delete)
		]);
	}

	showMultipleMaterialsActions = () => {
		return _.compact([
			_.capitalize(this.dic.CONSTANTS.actions.delete)
		]);
	}

	selectMultipleMaterialAction = (selectedMaterials, action) => {
		switch (action.toLowerCase()) {
			case this.dic.CONSTANTS.actions.delete:
				this.openDeleteFilesPopup(selectedMaterials);
				return;
		}
	}

	selectMaterialAction = (materialObj, action) => {
		switch (action.toLowerCase()) {
			case this.dic.CONSTANTS.actions.download:
				this.download([materialObj]);
				return;

			case 'edit':
				this.quizCreationPopup = {show: true, isEditMode: true, initialData: materialObj};
				return;

			case 'duplicate':
				this.quizCreationPopup = {show: true, initialData: {...materialObj, name: 'Copy of ' + materialObj.name}};
				return;

			case this.dic.CONSTANTS.actions.delete:
				this.openDeleteFilesPopup([materialObj]);
				break;
		}
	}

	download(materials) {
		if (!materials?.length) {
			return;
		}

		if (materials.length === 1) {
			this.gs.downloadFile('/admin/threatSimulation/material/content/' + materials[0]._id, materials[0], true, () => {});
		}
		/*else {
			const fileObj = {name: 'secure_attachments.zip', type: 'application/zip', size: _.sumBy(materials, 'size')};
			const fileIdsStr = _.map(materials, '_id').join(',');

			this.gs.downloadFile('/admin/threatSimulation/material/file/' + fileIdsStr, fileObj, false, () => {});
		}*/
	}

	openNewMaterialAiWizard = () => {
		if (this.aiMaterialPopup && !this.aiMaterialPopup.show) {
			this.aiMaterialPopup.show = true;
			return;
		}

		// preload ai creation success gif to cache
		if (!this.aiCreationGifLoaded) {
			const img = new Image();
			img.src = 'images/ai-spinner.gif';
			this.aiCreationGifLoaded = true;
		}

		this.aiMaterialPopup = {
			data: {
				title: '',
				description: '',
				botGender: 'Female',
				audience: this.aiMaterialAudienceOptions[0],
				videoLength: 1,
				files: [],
				file: null, // model
				attachments: [],
			},
			currentStep: this.aiMaterialPopupSteps.generalInformation,
			addMaterialsInProcess: false,
			error: false,
			show: true
		};
	}

	uploadAIVideoMediaFile = () => {
		if (!this.aiMaterialPopup.data.file?.name) {
			return;
		}

		if (this.aiMaterialPopup.data.file.type !== "image/png" && this.aiMaterialPopup.data.file.type !== "image/jpeg") {
			this.ns.showWarnMessage(this.dic.ERRORS.logoInvalidType);
			return;
		}

		// 500 KB
		if (this.aiMaterialPopup.data.file.size > 500000) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.fileMaxSizeX, '500KB'));
			return;
		}


		const reader = new FileReader();
		reader.addEventListener("load", () => {
			if (reader.result) {
				this.aiMaterialPopup.data.files.push({
					fileData: this.aiMaterialPopup.data.file,
					description: '',
					previewBase64: reader.result.toString().split(',')[1]
				});
			}
		}, false);

		reader.readAsDataURL(this.aiMaterialPopup.data.file);
	};

	removeAIVideoMediaFile = (fileToDelete) => {
		_.remove(this.aiMaterialPopup.data.files, (file:any) => fileToDelete.fileData.name === file.fileData.name);
	}

	openNewMaterialPopup = () => {
		this.newMaterialPopup = {
			type: 'file',
			link: {
				name: '',
				url: '',
				description: ''
			},
			uploadFile: null,
			addMaterialsInProcess: false,
			error: false,
			show: true
		};
	}

	openQuizCreationWizard = () => {
		this.newMaterialPopup = null;
		this.quizCreationPopup = {show: true};
	}

	onQuizCreated = (materialObj) => {
		if (this.quizCreationPopup?.isEditMode) {
			const idx = this.materials.findIndex(m => m._id === materialObj._id);
			if (idx !== -1) {
				this.materials[idx] = materialObj;
			}
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		} else {
			this.materials.unshift(materialObj);
			this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Quiz <b>' + materialObj.name + '</b>'));
		}
		this.updateMaterialsGallery();
		this.quizCreationPopup = null;
	}

	aiVideoWizardBackStep = () => {
		this.aiMaterialPopup.error = false;

		switch (this.aiMaterialPopup.currentStep) {
			case this.aiMaterialPopupSteps.materialDetails:
				this.aiMaterialPopup.currentStep = this.aiMaterialPopupSteps.generalInformation;
				break;

			case this.aiMaterialPopupSteps.generate:
				this.aiMaterialPopup.currentStep = this.aiMaterialPopupSteps.materialDetails;
				break;

			default:
				return;
		}
	}

	aiVideoWizardNextStep = () => {
		this.aiMaterialPopup.error = false;

		switch (this.aiMaterialPopup.currentStep) {
			case this.aiMaterialPopupSteps.generalInformation:
				this.aiMaterialPopup.currentStep = this.aiMaterialPopupSteps.materialDetails;
				break;

			case this.aiMaterialPopupSteps.materialDetails:
				if (!this.aiMaterialPopup.data.title.trim()) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Title'));
					this.aiMaterialPopup.error = true;
					return;
				}
				if (!this.aiMaterialPopup.data.description.trim()) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Video content'));
					this.aiMaterialPopup.error = true;
					return;
				}
				if (this.aiMaterialPopup.data.files?.length && this.aiMaterialPopup.data.files.some(file => !file.description.trim())) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Media file description'));
					this.aiMaterialPopup.error = true;
					return;
				}
				if (!this.aiMaterialPopup.data.audience) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.noSelected, 'audience'));
					this.aiMaterialPopup.error = true;
					return;
				}

				this.aiMaterialPopup.currentStep = this.aiMaterialPopupSteps.generate;
				break;

			default:
				return;
		}
	}

	generateAiVideo = () => {
		const data = {
			title: this.aiMaterialPopup.data.title,
			desc: this.aiMaterialPopup.data.description,
			audience: this.aiMaterialPopup.data.audience,
			videoLength: this.aiMaterialPopup.data.videoLength,
			botGender: this.aiMaterialPopup.data.botGender,
		};

		const formData = new FormData();
		// parameters
		for (const [key, value] of Object.entries(data) as any) {
			formData.append(key, value);
		}
		if (this.aiMaterialPopup.data.files?.length) {
			this.aiMaterialPopup.data.files.forEach((file) => {
				formData.append('file[]', file.fileData);
				formData.append('fileDesc[]', file.description);
			});
		}
		//

		this.aiMaterialPopup.addMaterialsInProcess = true;

		this.http.post(ENV_CONSTS.attachmentUrl + '/admin/threatSimulation/material/ai', formData, {headers: this.authService.getHeaders()})
			.subscribe((event:any) => {
				this.aiMaterialPopup = null;
				this.ns.showInfoMessage(this.dic.MESSAGES.aiCreateVideoSuccess);
				this.materials.unshift(event.materialObj);
				this.updateMaterialsGallery();
			}, (errEvent) => {
				this.aiMaterialPopup.addMaterialsInProcess = false;
				this.ns.showErrorMessage(errEvent.error.message);
			});

		/*this.aiMaterialPopup.addMaterialsInProcess = true;

		this.rs.createThreatSimulationAiMaterial(data).then((response) => {
			this.aiMaterialPopup = null;
			this.ns.showInfoMessage(this.dic.MESSAGES.aiCreateVideoSuccess);
			this.materials.unshift(response.materialObj);
			this.updateMaterialsGallery();
		}, err => {
			this.aiMaterialPopup.addMaterialsInProcess = false;
		});*/
	}

	confirmNewMaterialPopup = () => {
		if (this.newMaterialPopup.type === 'file') {
			if (!this.newMaterialPopup.uploadFile) {
				this.ns.showWarnMessage(util.format(this.dic.ERRORS.noSelected, 'file'));
				this.newMaterialPopup.error = true;
				return;
			}
			if (_.some(this.materials, {name: this.newMaterialPopup.uploadFile.name})) {
				this.newMaterialPopup.error = true;
				this.ns.showWarnMessage(util.format(this.dic.ERRORS.itemAlreadyExist, 'A material named: <b>' + this.newMaterialPopup.uploadFile.name + '</b>'));
				return;
			}

			this.newMaterialPopup.addMaterialsInProcess = true;
			this.uploads();
			return;
		}

		if (this.newMaterialPopup.type === 'link') {
			if (!this.newMaterialPopup.link.name || !this.newMaterialPopup.link.url) {
				this.newMaterialPopup.error = true;
				this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, !this.newMaterialPopup.link.name ? 'Name field' : 'URL field'))
				return;
			}
			if (_.some(this.materials, {name: this.newMaterialPopup.link.name})) {
				this.newMaterialPopup.error = true;
				this.ns.showWarnMessage(util.format(this.dic.ERRORS.itemAlreadyExist, 'A material named: <b>' + this.newMaterialPopup.link.name + '</b>'));
				return;
			}

			const linkObj = {
				name: this.newMaterialPopup.link.name,
				description: this.newMaterialPopup.link.description,
				link_url: this.newMaterialPopup.link.url,
			};

			this.newMaterialPopup.addMaterialsInProcess = true;

			this.rs.addThreatSimulationMaterialLink(linkObj).then((res) => {
				this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Link <b>' + linkObj.name + '</b>'));
				this.materials.unshift(res.materialObj);
				this.updateMaterialsGallery();
				this.newMaterialPopup = null;
				this.newMaterialPopup.addMaterialsInProcess = true;
			}, (err) => {
				this.newMaterialPopup.addMaterialsInProcess = true;
			});
		}
	}

	openDeleteFilesPopup = (materialObjs) => {
		let title, subTitle;
		if (materialObjs.length > 1) {
			title = 'Delete Materials';
			subTitle = `Please note - you are about to delete ${materialObjs.length} materials`;
		}
		else {
			title = 'Delete Material';
			subTitle = `Please note - you are about to delete ${materialObjs[0].name}`;

			if (materialObjs[0].system) {
				return this.ns.showErrorMessage(`Cannot delete system materials`);
			}
		}

		this.gs.showPopup({
			title: title,
			subTitle: subTitle,
			type: this.dic.CONSTANTS.popupWarning,
			doneBtnText: 'Delete',
			doneCb: () => {
				materialObjs.forEach((materialObj) => {
					if (materialObj.system) {
						return;
					}
					this.deleteMaterialExecute(materialObj);
				});
			}
		});
	};

	deleteMaterialExecute(materialObj) {
		this.rs.deleteThreatSimulationMaterials(materialObj._id).then(() => {
			_.remove(this.materials, materialObj);
			this.updateMaterialsGallery();

			if (this.currentMaterial?._id === materialObj._id) {
				this.currentMaterial = null;
			}
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
		});
	};

	uploadMultipleFiles(notIdx, cb) {
		this.gs.uploadMultipleFiles('/admin/threatSimulation/material', this.uploadQueue, notIdx, false).then((res:any) => {
			if (res.data?.error) {
				this.ns.closeMessage(notIdx);
				this.ns.showErrorMessage(res.data.message);
				this.newMaterialPopup.addMaterialsInProcess = false;
				return;
			}

			this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Material <b>' + this.uploadQueue[0].name + '</b>'));
			this.materials.unshift(res.data.materialObj);
			this.updateMaterialsGallery();

			this.newMaterialPopup = null;

			if (res.data?.length) {
				cb(null, notIdx, res.data.length);
			}
			else {
				cb(null, notIdx, 0);
			}
		}, err => {
			console.error(err);
			this.ns.closeMessage(notIdx);
			cb(err);
		});
	}

	searchMaterial = (searchTerm, activeFilters) => {
		this.materials.forEach((materialObj:any) => {
			// search
			if (searchTerm) {
				let isFound = searchTextExecute(materialObj, searchTerm);
				if (!isFound) {
					materialObj.hide = true;
					return;
				}
			}

			// filter
			if (activeFilters) {
				// need to match all filter types
				let numFilterToMatch = Object.keys(activeFilters).length;

				if (activeFilters['Material Type']?.length) {
					const isSameType = activeFilters['Material Type'].includes('PDF file') && materialObj.type === 'application/pdf' ||
						activeFilters['Material Type'].includes('Link') && materialObj.type === 'link' ||
						activeFilters['Material Type'].includes('Quiz') && materialObj.type === 'quiz' ||
						activeFilters['Material Type'].includes('Powerpoint presentation') && ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'].indexOf(materialObj.type) > -1 ||
						activeFilters['Material Type'].includes('Video') && (materialObj.type === 'Trustifi AI' || materialObj.type === 'Hook Security' || materialObj.type === 'AI' || materialObj.type === 'video/mp4');
					if (isSameType) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['Video Type']?.length) {
					const isSameType = activeFilters['Video Type'].includes('Trustifi AI video') && materialObj.type === 'Trustifi AI' ||
						activeFilters['Video Type'].includes('Hook Security video') && materialObj.type === 'Hook Security' ||
						activeFilters['Video Type'].includes('AI Generated video') && materialObj.type === 'AI';
					if (isSameType) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['Audience']?.length && materialObj.audience_role) {
					const audienceFilter = activeFilters['Audience'].map(a => a.toLowerCase());
					const matchesAudience = materialObj.audience_role.some(role =>
						audienceFilter.includes(role.toLowerCase())
					);
					if (matchesAudience) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['Skill Level']?.length && materialObj.skill_level?.length) {
					const skillFilter = activeFilters['Skill Level'].map(a => a.toLowerCase());
					if (skillFilter.includes(materialObj.skill_level)) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['Attack Type']?.length && materialObj.attack_type?.length) {
					const skillFilter = activeFilters['Attack Type'].map(a => a.toLowerCase());
					if (skillFilter.includes(materialObj.attack_type)) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['Delivery Vector']?.length && materialObj.delivery_vector?.length) {
					const audienceFilter = activeFilters['Delivery Vector'].map(a => a.toLowerCase());
					const matchesAudience = materialObj.delivery_vector.some(role =>
						audienceFilter.includes(role.toLowerCase())
					);
					if (matchesAudience) {
						numFilterToMatch--;
					}
				}

				if (activeFilters['Tags']?.length && materialObj.tags?.length) {
					const audienceFilter = activeFilters['Tags'].map(a => a.toLowerCase());
					const matchesAudience = materialObj.tags.some(role =>
						audienceFilter.includes(role.toLowerCase())
					);
					if (matchesAudience) {
						numFilterToMatch--;
					}
				}

				if (numFilterToMatch) {
					materialObj.hide = true;
					return;
				}
			}

			materialObj.hide = false;
		});
	};

	startEditCurrentMaterial = (fieldName) => {
		this.currentMaterial.edit = {
			...(this.currentMaterial.edit || {}),
			[fieldName]: this.currentMaterial[fieldName] || ''
		};
	}

	confirmEditCurrentMaterial = (fieldName) => {
		if (this.currentMaterial.edit[fieldName] === this.currentMaterial[fieldName]) {
			this.currentMaterial.edit[fieldName] = undefined;
			return;
		}
		if (!this.currentMaterial.edit[fieldName] || this.editMaterialInProcess) {
			return;
		}

		if (_.some(this.materials, {name: this.currentMaterial.edit[fieldName]})) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.itemAlreadyExist, 'A material named: <b>' + this.currentMaterial.edit[fieldName] + '</b>'));
			return;
		}

		this.editMaterialInProcess = true;

		const data = {
			type: fieldName,
			value: this.currentMaterial.edit[fieldName]
		};

		this.rs.updateThreatSimulationMaterial(this.currentMaterial._id, data).then(() => {
			this.ns.showInfoMessage(this.dic.MESSAGES.operationsSuccess);
			const materialInList = _.find(this.materials, {name: this.currentMaterial.name});

			this.currentMaterial[fieldName] = this.currentMaterial.edit[fieldName];
			this.currentMaterial.edit[fieldName] = undefined;
			materialInList[fieldName] = this.currentMaterial[fieldName];
			this.editMaterialInProcess = false;

			if (fieldName === 'link_url') {
				this.previewLinkMaterial = this.sanitizer.bypassSecurityTrustResourceUrl(this.currentMaterial.link_url);
			}

		}, err => {
			this.editMaterialInProcess = false;
		});
	}

	setCurrentMaterial = (material) => {
		this.updateMaterialSubtitleLanguages(material);

		// link material
		if (material.link_url) {
			this.currentMaterial = material;
			this.previewLinkMaterial = this.sanitizer.bypassSecurityTrustResourceUrl(this.currentMaterial.link_url);
			return;
		}

		// quiz material / AI
		if (material.type === 'quiz' || material.type === 'Trustifi AI' || material.type === 'Hook Security' || material.type === 'AI') {
			this.currentMaterial = material;
			return;
		}

		this.getMaterialFileDataInProcess = true;

		const fileExt = (material.name.split('.').pop()).toLowerCase();
		switch (fileExt) {
			case 'pdf':
				this.getMaterialFileDataInProcess = true;
				this.http.get(ENV_CONSTS.attachmentUrl + '/admin/threatSimulation/material/content/' + material._id,{
					responseType: 'arraybuffer',
					headers: this.gs.getHeaders(),
					observe: 'response'
				}).subscribe((response) => {
					if (response && response.body.byteLength === 0) {
						this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
					}

					this.currentMaterial = {
						...material,
						content: response,
						edit: null
					};

					this.getMaterialFileDataInProcess = false;
				}, err => {
					console.error(err);
					this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
					this.getMaterialFileDataInProcess = false;
				});
				break;

			case 'ppt':
			case 'pptx':
				this.getMaterialFileDataInProcess = true;
				this.rs.getThreatSimulationMaterialContentEnc(material._id).then((enc) => {
					const pptUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${ENV_CONSTS.outsideUrl}/ts/content/${enc}?materialId=${material._id}`;
					// console.log(ENV_CONSTS.outsideUrl, pptUrl);
					this.currentMaterial = {
						...material,
						edit: null,
						pptUrl: this.sanitizer.bypassSecurityTrustResourceUrl(pptUrl)
					};

					this.getMaterialFileDataInProcess = false;
				}, err => {
					console.error(err);
					this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
					this.getMaterialFileDataInProcess = false;
				});
				break;

			case 'mp4':
				this.getMaterialFileDataInProcess = true;
				this.http.get(ENV_CONSTS.attachmentUrl + '/admin/threatSimulation/material/content/' + material._id,{
					responseType: 'arraybuffer',
					headers: this.gs.getHeaders(),
					observe: 'response'
				}).subscribe((response) => {
					if (response && response.body.byteLength === 0) {
						this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
					}

					this.currentMaterial = {
						...material,
						content: response,
						edit: null
					};

					this.getMaterialFileDataInProcess = false;
				}, err => {
					console.error(err);
					this.ns.showErrorMessage(this.dic.ERRORS.fileDownloadFailed);
					this.getMaterialFileDataInProcess = false;
				});
				break;
		}
	}

	uploads = () => {
		if (!this.newMaterialPopup.uploadFile) {
			return;
		}

		let files = [this.newMaterialPopup.uploadFile];

		let isValid;
		this.uploadQueue = [];
		isValid = this.calcBlockSizeAndValidate(files);
		if (isValid) {
			let notIdx = this.ns.showInfoMessage(this.dic.MESSAGES.filesBlockUpload, {timeout: 0, showSpinner: true});

			if (files.length < this.dic.CONSTANTS.parallelFilesUploadCount) {
				this.uploadQueue = files;
				this.uploadMultipleFiles(notIdx, (err, notIdx, uploadedFiles) => {
					if (!err) {
						this.ns.overwriteMessage(notIdx, this.dic.MESSAGES.filesUploaded, null, {showSpinner: false});
					}
				});
				return;
			}
			this.alreadyUploadedFiles = 0;
			if (files?.length) {
				this.uploadBlocks(files, notIdx, files.length, () => {});
			}
		}
	}

	uploadBlocks(files, notIdx, totalFilesNumber, cb) {
		this.uploadQueue = files.splice(0, this.dic.CONSTANTS.parallelFilesUploadCount);

		this.uploadMultipleFiles(notIdx, (err, notIdx, uploadedFiles) => {
			// error in upload
			if (err) {
				return cb(err);
			}
			this.alreadyUploadedFiles += uploadedFiles;

			// finished current upload
			if (files.length === 0) {
				this.ns.overwriteMessage(notIdx, this.dic.MESSAGES.filesUploaded, null, {showSpinner: false});
				return cb(null);
			}
			else {
				this.ns.overwriteMessage(notIdx, util.format(this.dic.MESSAGES.uploadMultiBlockProgress, this.alreadyUploadedFiles, totalFilesNumber), null, {showSpinner: true});
			}
			// recursive call on the rest of files to upload
			this.uploadBlocks(files, notIdx, totalFilesNumber, cb);
		});
	}

	calcBlockSizeAndValidate(files) {
		let total = 0;
		_.each(files, file => {
			total += file.size;
		});
		return this.gs.checkUploadFileSize(total, 'Current uploading materials');
	}

	generateMaterialSubtitles = (materialObj) => {
		const selectedLangs = materialObj.subtitleLanguages
			.filter(option => option['selected'] && !option['disabled'])
			.map(option => option.code);

		if (!selectedLangs.length) {
			this.ns.showWarnMessage('Please select at least one language');
			return;
		}

		if (selectedLangs.length > 5) {
			this.ns.showWarnMessage(this.dic.ERRORS.maxSubtitleLanguages);
			return;
		}

		materialObj.generateSubtitlesInProcess = true;

		this.rs.generateThreatSimulationMaterialSubtitles(materialObj._id, {languages: selectedLangs}).then(() => {
			this.ns.showInfoMessage('Subtitle generation started. Check back in a few minutes.');

			if (!materialObj.video_subtitles) {
				materialObj.video_subtitles = [];
			}
			selectedLangs.forEach(lang => {
				materialObj.video_subtitles.push({lang, segments: ''});
				materialObj.subtitlesData.push({lang: this.dic.CONSTANTS.subtitleLanguages[lang], isInProcess: true});
			});

			this.updateMaterialSubtitleLanguages(materialObj);
			materialObj.generateSubtitlesInProcess = false;
		}, err => {
			materialObj.generateSubtitlesInProcess = false;
		});
	}

	updateMaterialSubtitleLanguages = (materialObj) => {
		materialObj.showAddSubtitles = false;
		materialObj.subtitleLanguages = Object.entries(this.dic.CONSTANTS.subtitleLanguages).map(([code, display]) => {
			const existingLanguage = (materialObj.video_subtitles || []).find(subtitles => subtitles.lang === code);

			return {
				selected: !!existingLanguage,
				disabled: !!existingLanguage,
				icon: existingLanguage?.segments ? 'far fa-closed-captioning' : (existingLanguage ? 'far fa-spinner fa-spin' : ''),
				explanation: existingLanguage?.segments ? null : (existingLanguage ? 'Subtitle generation in progress' : null),
				code,
				display
			};
		});
	}
}

function searchTextExecute(materialObj, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
	return materialObj.name?.toLowerCase().indexOf(searchTerm) > -1 ||
		materialObj.description?.toLowerCase().indexOf(searchTerm) > -1 ||
		materialObj.audience_role?.includes(searchTerm) ||
		materialObj.attack_type?.includes(searchTerm) ||
		materialObj.attack_type?.includes(searchTerm) ||
		materialObj.delivery_vector?.includes(searchTerm) ||
		materialObj.tags?.includes(searchTerm);
}
